import { QueryClient } from '@tanstack/react-query'

/**
 * Singleton QueryClient instance shared across the app.
 * Extracted to a module so hooks outside QueryClientProvider
 * (e.g. useTenantState inside AuthProvider) can clear caches
 * on tenant switch / logout to prevent cross-tenant data leaks.
 */
export const queryClient = new QueryClient()
